import track from './track'

/**
 * Most values returned from the service uses hyphen-minus (on the keyboard)
 * We need to replace them with the minus sign unicode 2212
 * https://en.wikipedia.org/wiki/Hyphen-minus
 *
 * @param {string} str
 * @returns {string}
 */
function fixNegativeSign (str) {
  if (typeof str === 'string') return str.replace(/[-]/g, '\u2212')
  else {
    track.error('format.fixNegativeSign only accepts string as input.')
    return str
  }
}

function addThousandsSeparator (str) {
  if (typeof str === 'string') {
    let numParts = str.split('.', 2)
    numParts[0] = numParts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    return numParts.join('.')
  } else {
    track.error('format.addThousandsSeparator only accepts string as input')
    return str
  }
}

export default { fixNegativeSign, addThousandsSeparator }
